// Finar rev-B 3 — formüllü (ƒx) hücre hover kartının saf içeriği + formül ifadesi maskeleme.
// Maskeleme FormulaPopover ile TEK kaynak (`maskedFormulaTokens`): portalda kodlar gösterge
// ETİKETİYLE yazılır, müşteriye kapalı girdi (grid'de olmayan kod — sunucu `gizli_N` maskesi dahil)
// ne ham kod ne humanize edilmiş ad gösterir: `KPI_COPY.portal.notes.hiddenInput`. Gizli kodun
// kendisi token'a (title/data) HİÇ taşınmaz. Danışman görünümünde ifade ham kodlarla kalır.

import type { KpiResolvedIndicator } from "@mahir/shared";
import { KPI_COPY } from "./kpi-ui";
import { tokenizeExpression } from "./portal-kpi-ui";

export interface MaskedFormulaToken {
  text: string;
  /** tanımlayıcı (gösterge atfı) — kalın yazılır */
  ref: boolean;
  /** görünür girdinin kodu (title için); gizli girdide YOK */
  code?: string;
}

/**
 * Portal ifadesi: kod → etiket, gizli kod → "erişiminiz olmayan gösterge". `hidden` FormulaPopover'ın
 * `hiddenInputs`'u ile aynı küme (`formulaInputsFor(...).hidden`).
 */
export function maskedFormulaTokens(
  expression: string,
  labelByCode: Record<string, string>,
  hidden: readonly string[],
): MaskedFormulaToken[] {
  const hiddenSet = new Set(hidden);
  const labels = {
    ...labelByCode,
    ...Object.fromEntries(hidden.map((c) => [c, KPI_COPY.portal.notes.hiddenInput])),
  };
  return tokenizeExpression(expression, labels).map((t) =>
    t.code === undefined
      ? { text: t.text, ref: false }
      : hiddenSet.has(t.code)
        ? { text: t.text, ref: true }
        : { text: t.text, ref: true, code: t.code },
  );
}

export interface FormulaHoverContent {
  title: string;
  description: string | null;
  /** aktif varyant etiketi (ör. "Varsayılan"); formül yoksa null */
  formulaLabel: string | null;
  /** danışman: ham ifade (tek token); portal: maskeli token'lar; formül yoksa null */
  tokens: MaskedFormulaToken[] | null;
  /** danışman görünümü (ifade monospace) */
  raw: boolean;
  noFormulaText: string;
  formulaHeading: string;
  moreText: string;
}

/**
 * Hover kartının içeriği. `client` verilirse (portal) etiket + maske ve AÇIKLAMA YOK (katalog
 * açıklaması danışman yüzeyidir — rev-B B1); verilmezse danışman (ham kod + açıklama, doluysa).
 */
export function formulaHoverContent(
  indicator: Pick<KpiResolvedIndicator, "label" | "formulas" | "activeFormulaId" | "description">,
  client?: { labelByCode: Record<string, string>; hidden: readonly string[] },
): FormulaHoverContent {
  const active =
    indicator.formulas.find((f) => f.id === indicator.activeFormulaId) ??
    indicator.formulas.find((f) => f.isActive);
  const copy = client ? KPI_COPY.portal.hover : KPI_COPY.cell.hover;
  // rev-B B1 — açıklama yalnız danışman yüzeyinde; portal kartı yalnız formül (DTO'da olsa bile)
  const description =
    !client && indicator.description?.trim() ? indicator.description.trim() : null;
  return {
    title: indicator.label,
    description,
    formulaLabel: active ? active.label : null,
    tokens: active
      ? client
        ? maskedFormulaTokens(active.expression, client.labelByCode, client.hidden)
        : [{ text: active.expression, ref: false }]
      : null,
    raw: !client,
    noFormulaText: copy.noFormula,
    formulaHeading: copy.formula,
    moreText: copy.more,
  };
}
